/** Graybox palette. The real pixel-art palettes arrive with src/art/. */

export const LANE_COLORS: readonly number[] = [
  0xf5efe0, // player: chalk white
  0xd96f5c, // brick
  0x6f8fd9, // cornflower
  0x7cc47c, // meadow
  0xd9c46f, // straw
  0xb07cc4, // heather (sixth lane, phase 5)
];

export function darken(color: number, factor: number): number {
  const r = Math.round(((color >> 16) & 0xff) * factor);
  const g = Math.round(((color >> 8) & 0xff) * factor);
  const b = Math.round((color & 0xff) * factor);
  return (r << 16) | (g << 8) | b;
}

export const TRACK_COLORS = {
  sky: 0x232936,
  skylineHill: 0x2c3344,
  dirt: 0x4a3b2a,
  dirtAlt: 0x51402e,
  rail: 0x2b2118,
  apron: 0x3a2f22,
  post: 0xd8d0c0,
  finishDark: 0x1a1a1a,
  finishLight: 0xe8e8e8,
} as const;

export function cssColor(color: number): string {
  return `#${color.toString(16).padStart(6, '0')}`;
}
